import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatOption } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import {
  MatSelect,
  MatSelectChange,
  MatSelectTrigger,
} from '@angular/material/select';
import { Router } from '@angular/router';
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  finalize,
  forkJoin,
  map,
  of,
  Subject,
  Subscription,
  tap,
} from 'rxjs';
import { LoginComponent } from 'src/app/core/components/login/login.component';
import { AuthService } from 'src/app/services/auth.service';
import { OfferService } from 'src/app/services/offer.service';
import { StorageService } from 'src/app/services/storage.service';
import { Role } from 'src/app/shared/enums/roles';
import { CardHolderEnum, OfferTypeEnum } from 'src/app/shared/enums/status';
import { IOffer } from 'src/app/shared/model/offer.model';
import { FilterService } from 'primeng/api';
import { ResponsiveService } from 'src/app/shared/utils/responsive.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  @ViewChild('categorySelect') categorySelect!: MatSelect;
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
  @ViewChild('scrollContainerMenu', { static: false })
  scrollContainerMenu!: ElementRef;
  tabs = [
    { title: 'Welcome Offer', value: OfferTypeEnum.WELCOME },
    { title: 'Partners Offer', value: OfferTypeEnum.PARTNER },
    { title: 'VISA Offer', value: OfferTypeEnum.VISA },
    // { title: 'RSTA Offer', value: OfferTypeEnum.RSTA },
    { title: 'TFOPTA Offer', value: OfferTypeEnum.TFOPTA },
    // { title: 'IMPACT Offer', value: OfferTypeEnum.IMPACT },
    // { title: 'Southern MICE District Offer', value: OfferTypeEnum.SOUTHERN },
  ];

  tabsVisa = [
    {
      title: 'For International Cardholder',
      value: CardHolderEnum.INTER,
    },
    {
      title: 'For Thai Cardholder',
      value: CardHolderEnum.THAI,
    },
  ];

  images = [
    '../assets/Logo_Partner/VISA.png',
    '../assets/Logo_Partner/Tceb.png',
  ];

  imagesStrategic = [
    '../assets/Logo_Partner/central_new.png',
    '../assets/Logo_Partner/centara_new.png',
    '../assets/Logo_Partner/robinson_new.png',
    '../assets/Logo_Partner/T2P_new.png',
    '../assets/Logo_Partner/RSPC.png',
    '../assets/Logo_Partner/gaysorn.png',
    '../assets/Logo_Partner/erawan.png',
    '../assets/Logo_Partner/central_world.png',
  ];

  imagesPartner = [
    '../assets/Logo_Partner/Bitec.png',
    '../assets/Logo_Partner/Impact.png',
    '../assets/Logo_Partner/QSNCC.png',
    '../assets/Logo_Partner/TEA.png',
    '../assets/Logo_Partner/Aleenta.png',
    '../assets/Logo_Partner/adlib.png',
    '../assets/Logo_Partner/buri.jpg',
    '../assets/Logo_Partner/monkam.png',
    '../assets/Logo_Partner/1 - Logo-kavin25year-01.png',
    '../assets/Logo_Partner/2 - Logo EEC.png',
    '../assets/Logo_Partner/3 - Logo EURO EXPO.png',
    '../assets/Logo_Partner/4 - Logo Koelnmesse_Logo_100Years_1.2.jpg',
    '../assets/Logo_Partner/5 - Logo_Stuttgart.png',
    '../assets/Logo_Partner/5 - LogoEGN-Final-01.png',
    '../assets/Logo_Partner/6 - Logo TIA.jpg',
    '../assets/Logo_Partner/7 - Logo C ASEAN.png',
    '../assets/Logo_Partner/8 - Logo DHOSPAAK.png',
    '../assets/Logo_Partner/ncc.png',
    '../assets/Logo_Partner/bkk.png',
    '../assets/Logo_Partner/antex.png',
    '../assets/Logo_Partner/standard.jpg',
    '../assets/Logo_Partner/digitaltech.jpg',
    '../assets/Logo_Partner/gml.png',
  ];

  selectedTab = 0;
  selectedTabVisa = 0;
  isLoading = false;
  pagination = false;
  subscription!: Subscription;
  isUser = false;
  currentPage = 1;
  pageSize: number = 50;
  totalPages: number | undefined;
  totalCount: number | undefined;
  offerList: IOffer[] = [];
  filterOffer!: IOffer[];
  redeemEnd: any;
  role!: Role;
  screenW: any;
  isInitLoading = false;

  filterList: string[] = [
    'DINING',
    'SHOPPING',
    'HEALTH&SPA',
    'AIRPORT LUGGAGE',
    'TRANSPORTATION',
    'LOGISTIC',
    'EDUCATION',
    'ACCOMMODATION',
    'ACTIVITY',
    'MEETING ROOM',
  ];

  filterListPartner: string[] = [
    'ACCOMMODATION',
    'ACTIVITY',
    'AIRPORT SERVICE',
    'DINING',
    'EDUCATION',
    'MEETING ROOM',
    'SHOPPING',
    'HEALTH&SPA',
  ];
  filterListInter: string[] = [
    'AIRPORT LUGGAGE',
    'DINING',
    'SHOPPING',
    'LOGISTIC',
    'TRANSPORTATION',
    'HEALTH&SPA',
    'AIRLINE',
    'OTA',
    'BUSINESS ESSENTIALS',
    'WELLNESS',
  ];
  filterListThai: string[] = [
    'AIRPORT LUGGAGE',
    'LOGISTIC',
    'TRANSPORTATION',
    'HEALTH&SPA',
    'AIRLINE',
    'OTA',
    'BUSINESS ESSENTIALS',
  ];
  filterListRSTA: string[] = ['DINING', 'HEALTH&SPA', 'ACCOMMODATION'];
  filterListImpact: string[] = [];
  filterListSouthern: string[] = [];
  filterListTFOPTA: string[] = ['ACCOMMODATION', 'ATTRACTION', 'DINING'];

  queryParams: any = {
    skip: this.currentPage,
    limit: this.pageSize,
    offerType: this.tabs[this.selectedTab].value,
    cardHolder: null,
    sortBy: 'merchantNameEN',
    sortOrderBy: 'asc',
  };
  RecommendQueryParams: any = {
    skip: this.currentPage,
    limit: this.pageSize,
    offerType: OfferTypeEnum.VISA,
    cardHolder: CardHolderEnum.THAI,
    sortBy: 'merchantNameEN',
    sortOrderBy: 'asc',
  };

  recommendedMerchant = [
    'Google Workspace',
    'DigitalOcean',
    'Perplexity',
    'Qatar Airways',
    'Grab',
  ];

  recommnededOfferList: IOffer[] = [];

  filterArray: any[] = [];
  private filterSubject = new BehaviorSubject<string[]>([]); // Stream for filter changes
  filterSub!: Subscription;

  constructor(
    public matDialog: MatDialog,
    private authService: AuthService,
    private offerService: OfferService,
    private router: Router,
    private storageService: StorageService,
    private filterService: FilterService,
    private responsiveService: ResponsiveService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    const width = this.document.defaultView?.innerWidth;
    this.screenW = width! < 640 ? 1 : 2;
  }

  remove(category: string): void {
    const index = this.filterArray.indexOf(category);

    if (index >= 0) {
      this.filterArray.splice(index, 1);

      // Manually uncheck the option
      if (this.categorySelect) {
        this.categorySelect.options.forEach((option: MatOption) => {
          if (option.value === category) {
            option.deselect(); // Deselect the corresponding option
          }
        });
      }
    }
  }

  ngOnInit(): void {
    // this.getOffer(false);
    this.getInitOffer();
    this.subscription = this.authService.currentUser.subscribe((user) => {
      this.isUser = Boolean(user);
      this.role = user?.roles;
      this.getRedeemEnd();
    });
    this.filterSubjectFn();

    const sub2 = this.storageService.changes.subscribe((data) => {
      if (data.key === 'profile') {
        this.getRedeemEnd(data.value);
      }
    });

    const sub3 = this.responsiveService.screenWidth$.subscribe((width) => {
      this.screenW = width < 640 ? 1 : 2;
    });

    this.subscription.add(sub2);
    this.subscription.add(sub3);
  }

  filterSubjectFn() {
    this.filterSub = this.filterSubject
      .pipe(
        debounceTime(300), // Wait 300ms after each input
      )
      .subscribe((filters: string[]) => {
        if (filters && filters.length > 0) {
          this.filterOffer = this.offerList?.filter((item: IOffer) =>
            this.filterService.filters['in'](
              item.category?.toLocaleUpperCase(),
              filters,
            ),
          );
        } else {
          this.filterOffer = [...this.offerList];
        }

        this.isLoading = false;
      });
  }

  getRedeemEnd(data?: any) {
    if (!Boolean(this.redeemEnd)) {
      const profile = localStorage.getItem('profile');

      if (profile) {
        const parseProfile = JSON.parse(profile);
        const date: any = new Date(parseProfile.createdAt);
        this.redeemEnd = new Date(date);
        this.redeemEnd.setMonth(this.redeemEnd.getMonth() + 3);
      } else if (Boolean(data)) {
        const date = new Date(data.createdAt);
        this.redeemEnd = new Date(date);
        this.redeemEnd.setMonth(this.redeemEnd.getMonth() + 3);
      }
    }
  }

  sortBy(sortType: string) {
    if (sortType === this.queryParams.sortBy) {
      if (this.queryParams.sortOrderBy === 'asc') {
        this.queryParams.sortOrderBy = 'desc';
      } else {
        this.queryParams.sortOrderBy = 'asc';
      }
    } else {
      this.queryParams.sortBy = sortType;
      this.queryParams.sortOrderBy = 'asc';
    }
  }

  changePage(newPage: number): void {
    if (newPage >= 1 && newPage <= this.totalPages!) {
      this.currentPage = newPage;
      this.queryParams.skip = this.currentPage;
    }
  }

  scrollLeft() {
    this.scrollContainer.nativeElement.scrollBy({
      left: -336,
      behavior: 'smooth',
    });
  }

  scrollRight() {
    this.scrollContainer.nativeElement.scrollBy({
      left: 336,
      behavior: 'smooth',
    });
  }

  scrollLeftMenu() {
    this.scrollContainerMenu.nativeElement.scrollBy({
      left: -336,
      behavior: 'smooth',
    });
  }

  scrollRightMenu() {
    this.scrollContainerMenu.nativeElement.scrollBy({
      left: 336,
      behavior: 'smooth',
    });
  }

  filterCategory(value: string[]) {
    // if (value.length > 0) {
    //   this.filterOffer = this.offerList.filter((item: IOffer) =>
    //     this.filterService.filters['in'](
    //       item.category?.toLocaleUpperCase(),
    //       value
    //     )
    //   );
    // } else {
    //   this.filterOffer = [...this.offerList];
    // }

    this.isLoading = true;
    this.filterSubject.next(value);
  }

  getInitOffer() {
    this.isInitLoading = true;
    this.isLoading = true;
    const normalOffer$ = this.offerService.getOfferByType(this.queryParams);
    const recommnededOffer$ = this.offerService.getOfferByType(
      this.RecommendQueryParams,
    );

    forkJoin([normalOffer$, recommnededOffer$])
      .pipe(
        tap(([normalOffer, recommnededOffer]) => {
          if (recommnededOffer) {
            if (recommnededOffer.data.totalData.length > 0) {
              // pinned any merchant as business requirement
              const offer: IOffer[] = [...recommnededOffer.data.totalData];

              this.recommnededOfferList = offer.filter((offer: IOffer) =>
                this.recommendedMerchant.some(
                  (item: any) =>
                    offer.merchantNameEN.toLocaleUpperCase() ===
                    item.toLocaleUpperCase(),
                ),
              );

              // const pinned: IOffer[] = offer.filter((offer: IOffer) =>
              //   this.recommendedMerchant.some(
              //     (item: any) =>
              //       offer.merchantNameEN.toLocaleUpperCase() ===
              //       item.toLocaleUpperCase()
              //   )
              // );

              // this.recommnededOfferList = pinned.sort(
              //   (a: IOffer, b: IOffer) => {
              //     const nameA = a.merchantNameEN.toLocaleUpperCase();
              //     const nameB = b.merchantNameEN.toLocaleUpperCase();
              //     if (nameA < nameB) {
              //       return -1;
              //     }
              //     if (nameA > nameB) {
              //       return 1;
              //     }
              //     return 0;
              //   }
              // );
            }
          }
        }),
        finalize(() => {
          ((this.isLoading = false), (this.isInitLoading = false));
        }),
      )
      .subscribe({
        next: ([normalOffer, recomendedOffer]) => {
          if (normalOffer) {
            this.totalCount = normalOffer.data.totalCount;

            this.offerList = normalOffer.data.totalData;

            this.filterCategory(this.filterArray);
          }
        },
        error: (err) => {
          console.log(err);
          this.isInitLoading = false;
          this.isLoading = false;
        },
      });
  }

  getOffer(isPagination: boolean) {
    this.isLoading = true;
    if (!isPagination) {
      this.currentPage = 1;
      this.queryParams.skip = this.currentPage;
    } else {
      this.pagination = true;
    }

    this.offerService
      .getOfferByType(this.queryParams)
      //pinned data feature on hold
      // .pipe(
      //   map((data: any) => {
      //     if (data.data.totalData.length > 0) {
      //       // pinned any merchant as business requirement
      //       const offer: IOffer[] = [...data.data.totalData];

      //       const pinned: IOffer[] = offer.filter((offer: IOffer) =>
      //         this.pinnedMerchant.some(
      //           (item: any) => offer.merchantNameEN === item
      //         )
      //       );

      //       const nonPinned: IOffer[] = offer.filter(
      //         (offer: IOffer) =>
      //           !this.pinnedMerchant.some(
      //             (item: any) => offer.merchantNameEN === item
      //           )
      //       );
      //       const offerWithPinned = [...pinned, ...nonPinned];
      //       data.data.totalData = [...offerWithPinned];
      //     }

      //     return data;
      //   })
      // )
      .subscribe({
        next: (data: any) => {
          this.totalCount = data.data.totalCount;

          if (isPagination) {
            if (this.offerList.length > 0) {
              this.offerList = [...this.offerList, ...data.data.totalData];
            } else {
              this.offerList = data.data.totalData;
            }
          } else {
            this.offerList = data.data.totalData;
          }

          this.filterCategory(this.filterArray);
          this.pagination = false;
        },
        error: (err) => {
          console.log(err);
          this.isLoading = false;
          this.pagination = false;
        },
      });
    // if (
    //   (this.isUser && this.role === 'USER') ||
    //   ((!this.isUser || this.role !== 'USER') &&
    //     this.queryParams.offerType !== OfferTypeEnum.WELCOME)
    // ) {
    //   if (!isPagination) {
    //     this.currentPage = 1;
    //     this.queryParams.skip = this.currentPage;
    //   } else {
    //     this.pagination = true;
    //   }

    //   this.offerService.getOfferByType(this.queryParams).subscribe({
    //     next: (data: any) => {
    //       this.totalCount = data.data.totalCount;

    //       if (isPagination) {
    //         if (this.offerList.length > 0) {
    //           this.offerList = [...this.offerList, ...data.data.totalData];
    //         } else {
    //           this.offerList = data.data.totalData;
    //         }
    //       } else {
    //         this.offerList = data.data.totalData;
    //       }

    //       this.filterCategory(this.filterArray);
    //       this.pagination = false;
    //     },
    //     error: (err) => {
    //       console.log(err);
    //       this.isLoading = false;
    //       this.pagination = false;
    //     },
    //   });
    // } else {
    //   this.isLoading = false;
    // }
  }

  onSelectCardHolder(event: any) {
    this.filterArray = [];

    this.getOffer(false);
  }

  onSelectTab(index: number, topic: string) {
    if (!this.isLoading) {
      this.filterArray = [];
      if (topic === 'main') {
        const tempObj = { ...this.queryParams };
        const previousTab = tempObj.offerType;
        this.selectedTab = index;
        this.queryParams.offerType = this.tabs[this.selectedTab].value;
        if (previousTab !== this.queryParams.offerType) {
          if (this.tabs[this.selectedTab].value === OfferTypeEnum.VISA) {
            if (
              this.tabsVisa[this.selectedTabVisa].value === CardHolderEnum.THAI
            ) {
              this.queryParams.cardHolder = CardHolderEnum.THAI;
            } else {
              this.queryParams.cardHolder = CardHolderEnum.INTER;
            }
          } else {
            this.queryParams.cardHolder = null;
          }
          this.getOffer(false);
        }
      } else {
        const tempObjVisa = { ...this.queryParams };
        const previousTabVisa = tempObjVisa.cardHolder;
        this.selectedTabVisa = index;
        this.queryParams.cardHolder = this.tabsVisa[this.selectedTabVisa].value;
        if (previousTabVisa !== this.queryParams.cardHolder) {
          this.getOffer(false);
        }
      }
    }
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }

  onScroll = () => {
    if (this.offerList && this.totalCount && !this.isLoading) {
      if (this.offerList?.length < this.totalCount!) {
        this.currentPage++;
        this.queryParams.skip = this.currentPage;
        this.getOffer(true);
      }
    }
  };

  onOpenLoginDialog() {
    const optionSM = {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '300ms',
      minWidth: '100%',
    };
    const option = {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '300ms',
      width: '480px',
    };

    const selectOption = this.screenW === 1 ? optionSM : option;

    const dialogRef = this.matDialog.open(LoginComponent, selectOption);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.filterSub.unsubscribe();
  }
}
